window.addEventListener('DOMContentLoaded', function () {
  if (window.jQuery) {
    $(function () {


      /*===============================================
      RADIOアコーディオンメニュー：常にアニメーションで開閉（初期表示も含む）
      ===============================================*/
      const SEL = 'dl.CL-RadioAccordionMenu';
      const DURATION = 180; // 統一アニメ時間(ms)

      function openSection($dl, $dt, animate = true) {
        const $dd = $dt.next('dd');

        // 他は閉じる（終端ジャンプしない stop(true,false) を使用）
        $dl.children('dd:visible')
          .not($dd)
          .stop(true, false)
          .slideUp(DURATION)
          .attr('aria-hidden', 'true')
          .prev('dt').attr('aria-expanded', 'false');

        if ($dd.is(':visible')) {
          $dt.attr('aria-expanded', 'true');
          return;
        }

        if (animate) {
          // hide → slideDown で必ずアニメ挙動に
          $dd.stop(true, false).hide().slideDown(DURATION).attr('aria-hidden', 'false');
        } else {
          $dd.stop(true, false).show().attr('aria-hidden', 'false');
        }
        $dt.attr('aria-expanded', 'true');
      }

      // 初期化：全閉じ → checked のみ「アニメで」開く
      $(SEL).each(function () {
        const $dl = $(this);
        const $dds = $dl.children('dd');
        $dds.hide().attr('aria-hidden', 'true');
        $dl.find('> dt').attr('aria-expanded', 'false');

        const $checked = $dl.find('> dt input[type="radio"]:checked').first();
        if ($checked.length) {
          openSection($dl, $checked.closest('dt'), true); // 初期もアニメ
        }
      });

      // 変更時：常にアニメーションで開閉
      $(document).on('change', SEL + ' > dt input[type="radio"]', function () {
        const $radio = $(this);
        const $dl = $radio.closest('dl.CL-RadioAccordionMenu');
        const $dt = $radio.closest('dt');
        openSection($dl, $dt, true);
      });

      // 動的差し込み用：任意の root 配下を再初期化（常にアニメ）
      window.RadioAccordionInit = function (root) {
        const $root = root ? $(root) : $(document);
        $root.find(SEL).each(function () {
          const $dl = $(this);
          const $dds = $dl.children('dd');
          $dds.hide().attr('aria-hidden', 'true');
          $dl.find('> dt').attr('aria-expanded', 'false');
          const $checked = $dl.find('> dt input[type="radio"]:checked').first();
          if ($checked.length) openSection($dl, $checked.closest('dt'), true);
        });
      };



      /*===============================================
      タブリスト（汎用対応版）
      ページ内に複数配置可：各 .TabSection ごとに独立動作
      ===============================================*/
      $(function () {
        $('.TabSection').each(function () {
          const $section = $(this);
          const $tabs = $section.find('ul.Tab > li > a');

          $tabs.on('click', function (e) {
            e.preventDefault();
            const $a = $(this);
            const target = $a.attr('href');

            // active切替
            const $ul = $a.closest('ul.Tab');
            $ul.find('li').removeClass('active');
            $a.parent().addClass('active');

            // ARIA更新
            $ul.find('a[role="tab"]').attr('aria-selected', 'false');
            $a.attr('aria-selected', 'true');

            // パネル切替（このセクション内だけ）
            $section.find('.TabPanel').hide();
            $section.find(target).show();
          });
        });
      });




      /*===============================================
ヘッダー固定ナビゲーション
===============================================*/
      (function ($) {
        var $win = $(window);
        var $nav = $('#CL-MainNavi');
        if (!$nav.length) return;

        // 既に存在していれば再利用（多重挿入防止）
        var $spacer = $('#CL-MainNaviSpacer');
        if (!$spacer.length) {
          $spacer = $('<div id="CL-MainNaviSpacer" aria-hidden="true"></div>');
          $spacer.insertBefore($nav);
        }

        var navTop = 0;
        var navHeight = 0;
        var ticking = false;
        var fixedTopPx = 0;

        function getFixedTopPx() {
          // 既存の sticky オフセット（top）をそのまま流用
          // 例: .StickyUnderHeader { top:60px / 70px } を尊重
          var t = parseInt(window.getComputedStyle($nav.get(0)).top, 10);
          return isNaN(t) ? 0 : t;
        }

        function updateMetrics() {
          // Spacerの位置を基準にすることで、固定化・解除でのズレを回避
          navHeight = $nav.outerHeight(true);
          navTop = $spacer.offset().top;
          fixedTopPx = getFixedTopPx();
        }

        function onScroll() {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            var sc = $win.scrollTop();
            if (sc > navTop) {
              if (!$nav.hasClass('NaviFixed')) {
                $nav.addClass('NaviFixed').css('top', fixedTopPx + 'px');
                $spacer.height(navHeight); // レイアウトを保持
              }
            } else {
              if ($nav.hasClass('NaviFixed')) {
                $nav.removeClass('NaviFixed').css('top', '');
                $spacer.height(0);
              }
            }
            ticking = false;
          });
        }

        // リサイズや向き変更で再計測
        $win.on('resize orientationchange', function () {
          updateMetrics();
          onScroll();
        });

        // ナビ自体の高さ変化（折返し・フォントロード・DOM変化）を監視
        if ('ResizeObserver' in window) {
          var ro = new ResizeObserver(function () {
            updateMetrics();
            onScroll();
          });
          ro.observe($nav.get(0));
        } else {
          // フォールバック（フォント遅延読込対策）
          setTimeout(function () { updateMetrics(); onScroll(); }, 800);
        }

        // 初期化
        updateMetrics();
        onScroll();
        $win.on('scroll', onScroll);
      })(jQuery);



      // ================================================
      //  showBottomWidget を“通過したら”固定バーを表示
      //  - まだ到達していない（trigger が下にある = rect.top >= vh）：非表示
      //  - trigger が見えている（交差中）：非表示
      //  - trigger を通過して上に抜けた（rect.bottom <= 0）：表示
      //  初期位置も含め、常に上記ルールで判定します。
      // ================================================
      if (!window.jQuery) return;

      (function ($) {
        var $triggers = $('.showBottomWidget');
        if (!$triggers.length) return;

        function setupPair(triggerEl, fixedSel) {
          var fixedEl = document.querySelector(fixedSel || '#FixedBottomWidget');
          if (!fixedEl) return;

          var isFixed = false;
          var isVisible = false;
          var ticking = false;

          function setAria(hidden) {
            fixedEl.setAttribute('aria-hidden', hidden ? 'true' : 'false');
          }

          function showFixed() {
            if (!isFixed) {
              isFixed = true;
              fixedEl.classList.add('is-fixed');
              requestAnimationFrame(function () {
                isVisible = true;
                fixedEl.classList.add('is-visible');
                setAria(false);
              });
            }
          }

          function hideFixed() {
            if (isFixed) {
              if (isVisible) {
                isVisible = false;
                fixedEl.classList.remove('is-visible');
              }
              var onEnd = function (ev) {
                if (ev.propertyName === 'transform' || ev.propertyName === 'opacity') {
                  fixedEl.classList.remove('is-fixed');
                  isFixed = false;
                  setAria(true);
                  fixedEl.removeEventListener('transitionend', onEnd);
                }
              };
              fixedEl.addEventListener('transitionend', onEnd);
            } else {
              // まだ固定化していない=初期状態も aria を閉じておく
              setAria(true);
            }
          }

          function evaluateByRect() {
            var r = triggerEl.getBoundingClientRect();
            var vh = window.innerHeight || document.documentElement.clientHeight;

            // 交差（見えている） → 非表示
            var inView = (r.top < vh && r.bottom > 0);
            if (inView) {
              hideFixed();
              return;
            }

            // まだ到達していない（下にある）→ 非表示
            if (r.top >= vh) {
              hideFixed();
              return;
            }

            // 上に通過した（完全に上へ抜けた）→ 表示
            if (r.bottom <= 0) {
              showFixed();
              return;
            }

            // それ以外の境界付近は安全側で非表示
            hideFixed();
          }

          var io = new IntersectionObserver(function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
              evaluateByRect();
              ticking = false;
            });
          }, {
            root: null,
            rootMargin: '0px 0px -2% 0px',
            threshold: [0, 0.01]
          });

          io.observe(triggerEl);

          // リサイズや回転でも再評価
          window.addEventListener('resize', evaluateByRect);
          window.addEventListener('orientationchange', evaluateByRect);

          // 初期評価（リロード位置反映）。初期は確実に非表示から。
          setAria(true);
          evaluateByRect();
        }

        $triggers.each(function () {
          var triggerEl = this;
          var fixedSel = triggerEl.getAttribute('data-fixed-target') || '#FixedBottomWidget';
          setupPair(triggerEl, fixedSel);
        });
      })(jQuery);





      // ================================================
      //  showTopWidget を“通過したら”固定バーを表示
      //  - まだ到達していない（trigger が下にある = rect.top >= vh）：非表示
      //  - trigger が見えている（交差中）：非表示
      //  - trigger を通過して上に抜けた（rect.bottom <= 0）：表示
      //  初期位置も含め、常に上記ルールで判定します。
      // ================================================
      (function ($) {
        var $triggers = $('.showTopWidget');
        if (!$triggers.length) return;

        function setupTopPair(triggerEl, fixedSel) {
          var fixedEl = document.querySelector(fixedSel || '#FixedTopWidget');
          if (!fixedEl) return;

          var isFixed = false;
          var isVisible = false;
          var ticking = false;

          function setAria(hidden) {
            fixedEl.setAttribute('aria-hidden', hidden ? 'true' : 'false');
          }

          function showFixed() {
            if (!isFixed) {
              isFixed = true;
              fixedEl.classList.add('is-fixed');
              requestAnimationFrame(function () {
                isVisible = true;
                fixedEl.classList.add('is-visible');
                setAria(false);
              });
            }
          }

          function hideFixed() {
            if (isFixed) {
              if (isVisible) {
                isVisible = false;
                fixedEl.classList.remove('is-visible');
              }
              var onEnd = function (ev) {
                if (ev.propertyName === 'transform' || ev.propertyName === 'opacity') {
                  fixedEl.classList.remove('is-fixed');
                  isFixed = false;
                  setAria(true);
                  fixedEl.removeEventListener('transitionend', onEnd);
                }
              };
              fixedEl.addEventListener('transitionend', onEnd);
            } else {
              // まだ固定化していない=初期状態も aria を閉じておく
              setAria(true);
            }
          }

          function evaluateByRect() {
            var r = triggerEl.getBoundingClientRect();
            var vh = window.innerHeight || document.documentElement.clientHeight;

            // 交差（見えている） → 非表示
            var inView = (r.top < vh && r.bottom > 0);
            if (inView) {
              hideFixed();
              return;
            }

            // まだ到達していない（下にある）→ 非表示
            if (r.top >= vh) {
              hideFixed();
              return;
            }

            // 上に通過した（完全に上へ抜けた）→ 表示
            if (r.bottom <= 0) {
              showFixed();
              return;
            }

            // それ以外の境界付近は安全側で非表示
            hideFixed();
          }

          var io = new IntersectionObserver(function () {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function () {
              evaluateByRect();
              ticking = false;
            });
          }, {
            root: null,
            rootMargin: '0px 0px -2% 0px',
            threshold: [0, 0.01]
          });

          io.observe(triggerEl);

          // リサイズや回転でも再評価
          window.addEventListener('resize', evaluateByRect);
          window.addEventListener('orientationchange', evaluateByRect);

          // 初期評価（リロード位置反映）。初期は確実に非表示から。
          setAria(true);
          evaluateByRect();
        }

        $triggers.each(function () {
          var triggerEl = this;
          var fixedSel = triggerEl.getAttribute('data-fixed-target') || '#FixedTopWidget';
          setupTopPair(triggerEl, fixedSel);
        });
      })(jQuery);



      /*===============================================
         写真スクロールインアニメーション
         - .js-photo-reveal 要素がビューポートに入ったら
           is-visible クラスを付与してCSSアニメーションさせます。
       ===============================================*/
      (function () {
        var nodes = document.querySelectorAll('.js-photo-reveal');
        if (!nodes.length) {
          return;
        }

        // NodeList -> Array（古めのブラウザ対策）
        var elements = Array.prototype.slice.call(nodes);

        // IntersectionObserver 非対応環境では、常に表示だけにしておく
        if (!('IntersectionObserver' in window)) {
          elements.forEach(function (el) {
            el.classList.add('is-visible');
          });
          return;
        }

        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              // 1回表示したら監視解除（パフォーマンス＆チラつき防止）
              io.unobserve(entry.target);
            }
          });
        }, {
          threshold: 0.5 // 要素の50%が見えたら発火
        });

        elements.forEach(function (el) {
          io.observe(el);
        });
      })();


      /*===============================================
         汎用スクロールインアニメーション（.reveal）
         - 画像専用の .js-photo-reveal の汎用版。テキストやカード等にも使える。
         - .reveal 要素がビューポートに入ったら is-visible を付与し、
           common-extend.css 側の transition でふわっと表示させます。
         - threshold を小さめ(0.12)＋下端を少し手前(rootMargin)に取り、
           文章ブロックでも「少し見えたら動き出す」自然な発火にしています。
         - IntersectionObserver 非対応環境では全要素を即表示にして、
           コンテンツが見えなくなる事故を防ぎます（プログレッシブエンハンスメント）。
       ===============================================*/
      (function () {
        var nodes = document.querySelectorAll('.reveal');
        if (!nodes.length) {
          return;
        }

        // NodeList -> Array（古めのブラウザ対策）
        var elements = Array.prototype.slice.call(nodes);

        // IntersectionObserver 非対応環境では、常に表示だけにしておく
        if (!('IntersectionObserver' in window)) {
          elements.forEach(function (el) {
            el.classList.add('is-visible');
          });
          return;
        }

        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              // 1回表示したら監視解除（パフォーマンス＆チラつき防止）
              io.unobserve(entry.target);
            }
          });
        }, {
          threshold: 0.12,                 // 要素の12%が見えたら発火
          rootMargin: '0px 0px -8% 0px'    // 画面下端の少し手前で発火させる
        });

        elements.forEach(function (el) {
          io.observe(el);
        });
      })();

    });
  }
});
